import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { AlertBannerService, AlertType } from '../../../../lib/alert-banner';
import { SurveyService } from 'src/app/services/survey/survey.service';

@Component({
  selector: 'app-edit-resolution-modal',
  templateUrl: './edit-resolution-modal.component.pug',
  styleUrls: ['./edit-resolution-modal.component.scss'],
  standalone: false
})
export class EditResolutionModalComponent implements OnInit {

  @Input() checkId;
  @Input() refereeId;
  @Output() statusChange= new EventEmitter<string>();

  constructor(public _bsModalRef: BsModalRef, 
    private alertList: AlertBannerService,
    private surveyService: SurveyService) { }

  ngOnInit(): void {
  }

  submit() {
    
    const getResolutionSuccess = (resp) => {
        this.statusChange.emit("valid");
        this._bsModalRef.hide();
    };

    const getResolutionError = () => {
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize `Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      this.statusChange.emit("suspicious");
      this._bsModalRef.hide();
    };

    this.surveyService
      .addUnusualActivityResolution(this.checkId, this.refereeId, 0).subscribe(getResolutionSuccess, getResolutionError);
  }

  cancel() {
    this._bsModalRef.hide();
  }

}
